export const parseCookies = (cookies: string): Map<string, string> => {
  const utmCookies = cookies
    .split(";")
    .map((item) => item.split("="))
    .reduce((acc, [k, v]) => (acc[k.trim().replace('"', "")] = v) && acc, {});
  if (utmCookies === undefined || utmCookies === {}) return new Map();
  return utmCookies && new Map(Object.entries(utmCookies));
};
